import React from 'react';
import { Button, Empty, Spin } from 'antd';
import StaticNotification from 'components/components/Notification/StaticNotification';
import DrawerTitleContent, { getRequestTitle } from 'components/components/Drawer/components/DrawerTitle/Content';
import RequestDetailsStatusContent from 'components/components/Drawer/components/DrawerTitle/components/RequestDetailsStatus/Content';
import { STATUS_COLOR_CLASS } from 'components/RequestsOverview/components/RequestDetailsDrawer/utils/constants';
import { NUMBER_TO_REQUEST_STATUS_MAP } from 'packages/service_request_repository/utils/constants';
import { PortalRequestItem } from 'packages/venture_builder_repository/portal/types';
import { requestStatusLabels } from 'packages/venture_builder_repository/portal/utils';
import { parseNumberToPrice } from 'utils/helpers/priceFormatters';

export const money = (value: number) => parseNumberToPrice(value, 'AED');

export { startupLabel } from 'packages/venture_builder_repository/utils/converters';

export const RequestTitle = ({ items, status }: { items: PortalRequestItem[], status: number }) => (
  <DrawerTitleContent title={getRequestTitle(items)}>
    <RequestDetailsStatusContent
      label={requestStatusLabels[status] || 'Unknown'}
      className={STATUS_COLOR_CLASS()[NUMBER_TO_REQUEST_STATUS_MAP[status] || 'rejected']}
    />
  </DrawerTitleContent>
);

export const LoadError = ({ error, retry }: { error: Error, retry: () => void }) => (
  <StaticNotification type="warning" message={error.message} primaryButton={{ text: 'Retry', onClick: retry }} />
);

export const Loading = () => <div className="vb-portal__loading"><Spin tip="Loading..." /></div>;

export const EmptyPortfolio = () => <Empty description="No startups in your portfolio. Please contact HUB71." />;

export const Refresh = ({ onClick, loading }: { onClick: () => void, loading: boolean }) => (
  <Button className="secondary-button" onClick={onClick} loading={loading}>Refresh</Button>
);
